import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

const inputCls = "w-full border border-[#CFCFCB] bg-white px-3 py-2.5 font-ui text-sm outline-none focus:border-[var(--ink)] transition-colors";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5">
      <form onSubmit={submit} className="w-full max-w-sm bg-white border border-[var(--rule)] p-8" data-testid="admin-login-form">
        <p className="font-display text-3xl font-bold">uk<span className="italic font-medium">discovered</span></p>
        <p className="meta mt-2">Admin login</p>
        <label className="block mt-8 meta !text-[var(--ink-2)]" htmlFor="email">Username</label>
        <input id="email" type="text" autoComplete="username" required value={email} onChange={(e) => setEmail(e.target.value)} className={`${inputCls} mt-2`} data-testid="admin-username-input" />
        <label className="block mt-5 meta !text-[var(--ink-2)]" htmlFor="password">Password</label>
        <input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={`${inputCls} mt-2`} data-testid="admin-password-input" />
        {error && <p className="mt-4 font-ui text-sm text-[var(--accent)]" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={busy} className="mt-7 w-full bg-[var(--ink)] text-white font-ui text-sm py-3 hover:bg-[var(--accent)] transition-colors disabled:opacity-60" data-testid="admin-login-submit-button">
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
